
import { HttpErrorResponse } from "@angular/common/http";
import { Component, OnDestroy } from "@angular/core";
import {
  FormControl,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { TranslateModule } from "@ngx-translate/core";
import {
  RECAPTCHA_V3_SITE_KEY,
  RecaptchaFormsModule,
  RecaptchaModule,
  RecaptchaV3Module,
  ReCaptchaV3Service,
} from "ng-recaptcha-2";
import { catchError, finalize, of, Subject, takeUntil, tap } from "rxjs";
import { AuthService } from "../../../app/services/auth.service";
import { SnackBarService } from "../../../app/services/snack-bar.service";
import { environment } from "../../../environments/environment";
import { ButtonComponent } from "../button/button.component";
import { PageHeaderComponent } from "../page-header/page-header.component";
interface PasswordRecoveryData {
  user: {
    email: string;
  };
  recaptcha_token: string;
}

@Component({
  selector: "app-modal-password-recovery",
  imports: [
    ReactiveFormsModule,
    TranslateModule,
    RecaptchaModule,
    RecaptchaFormsModule,
    RecaptchaV3Module,
    FormsModule,
    MatDialogModule,
    ButtonComponent,
    PageHeaderComponent
],
  providers: [
    {
      provide: RECAPTCHA_V3_SITE_KEY,
      useValue: environment.RECAPTCHA_SITE_KEY_V3,
    },
  ],
  templateUrl: "./modal-password-recovery.component.html",
  styleUrl: "./modal-password-recovery.component.scss",
})
export class ModalPasswordRecoveryComponent implements OnDestroy {
  email: string = "";

  emailCtrl = new FormControl("", [Validators.email, Validators.required]);
  private destroy$ = new Subject<void>();
  loading = false;

  constructor(
    public dialogRef: MatDialogRef<ModalPasswordRecoveryComponent>,
    private readonly recaptchaV3Service: ReCaptchaV3Service,
    private readonly authService: AuthService,
    private readonly snackService: SnackBarService,
  ) {}

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  close(): void {
    const closeMessage = "Modal closed";
    this.dialogRef.close(closeMessage);
  }

  send(): void {
    if (this.emailCtrl.invalid) {
      this.emailCtrl.markAsTouched();
      return;
    }
    const email = this.emailCtrl.value;

    this.loading = true;

    this.recaptchaV3Service
      .execute("submit")
      .pipe(
        catchError((error) => {
          this.loading = false;
          return of(error);
        }),
      )
      .subscribe((token: string) => {
        const data: PasswordRecoveryData = {
          user: { email: email! },
          recaptcha_token: token,
        };
        this.resetPasswordRequest(data);
      });
  }

  resetPasswordRequest(data: PasswordRecoveryData) {
    this.authService
      .resetPassword(data)
      .pipe(
        takeUntil(this.destroy$),
        tap((response) => {
          this.snackService.openSnackBar(
            "Solicitação de recuperação de senha enviada, verifique seu email!",
            "Fechar",
            "success",
          );
          this.dialogRef.close();
        }),
        catchError((err: HttpErrorResponse) => {
          const status = (err as HttpErrorResponse)?.status ?? err;

          if (status === 422) {
            const errorMessage = err.error?.errors[0];

            if (errorMessage === "Email not found") {
              this.snackService.openSnackBar(
                "O email fornecido não está registrado.",
                "Fechar",
                "error",
              );
            } else {
              this.snackService.openSnackBar(
                "O email fornecido é inválido ou não está registrado.",
                "Fechar",
                "error",
              );
            }
          } else {
            this.snackService.openSnackBar(
              "Ocorreu um erro ao enviar a solicitação de recuperação de senha.",
              "Fechar",
              "error",
            );
          }

          console.error("Erro ao enviar requisição para resetar senha", err);
          return of(null);
        }),
        finalize(() => (this.loading = false)),
      )
      .subscribe();
  }
}
